import React from "react";
import { Helmet } from "react-helmet-async";
import ParticlesBackground from "./ParticlesBackground";
import "./Abouthero.css";
import DesignImage from "./images/homepage-illustration1-svg.png";

const Hero = ({ isDarkMode }) => {

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Corporation",
    name: "AstraSight Technologies",
    url: "https://astrasighttech.com",
    logo: "https://astrasighttech.com/images/asighticon1.png",
    description:
      "AstraSight Technologies specializes in web development, app development, software solutions, cybersecurity, and digital marketing for businesses across Africa.",
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+254791865638",
      contactType: "customer service",
      areaServed: "KE",
      availableLanguage: ["English"],
    },
    address: {
      "@type": "PostalAddress",
      streetAddress: "Nairobi, Kenya",
      addressLocality: "Nairobi",
      addressCountry: "KE",
    },
  };

  return (
    <>
      <Helmet>
        <title>About AstraSight Technologies - Digital Solutions in Kenya & Africa</title>
        <meta
          name="description"
          content="AstraSight Technologies, based in Nairobi, Kenya, provides web development, software solutions, cybersecurity, branding, and digital marketing to businesses across Africa."
        />
        <meta
          name="keywords"
          content="web development, software solutions, cybersecurity, digital marketing, AstraSight Technologies, IT solutions Kenya, IT solutions Africa"
        />
        <meta name="author" content="AstraSight Technologies" />
        <meta
          property="og:title"
          content="About AstraSight Technologies - Digital Solutions in Kenya & Africa"
        />
        <meta
          property="og:description"
          content="Learn about AstraSight Technologies and how we help businesses in Kenya and across Africa thrive with modern digital solutions."
        />
        <meta
          property="og:image"
          content="https://astrasighttech.com/about-banner.png"
        />
        <meta property="og:url" content="https://astrasighttech.com/about" />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      <section className={`heroabout ${isDarkMode ? "dark" : "light"}`}>

        {/* 🌐 PARTICLES (shared component) */}
        <ParticlesBackground isDarkMode={isDarkMode} />

        <div className="heroabout-content">
   <div className="content-left">
  <div className="text-container with-line">
    <h1 className="about-heading">About AstraSight Technologies</h1>
    <p className="about-paragraph">
      AstraSight Technologies is a leading digital solutions provider...
    </p>
  </div>
</div>


          <div className="image-container">
            <img
              className="about-image"
              src={DesignImage}
              alt="AstraSight Technologies - Leading Digital Solutions Provider in Kenya and Africa"
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero;
